// extracted by mini-css-extract-plugin
module.exports = {"popup":"cookiesPopup_popup__KBnKk","popupText":"cookiesPopup_popupText__siE5F","acceptButton":"cookiesPopup_acceptButton__O34iR"};